<template>
    <div v-show="isModalGroupVisible">
        <transition name="slide">
            <div class="modal-mask">
                <div class="modal-dialog modal-dialog-slideout modal-lg">
                    <div class="modal-content p-2">
                        <div class="modal-header">
                          <div class="width-100">
                            <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                            <button type="button" class="close float-right" @click="hide">
                              <span aria-hidden="true">&times;</span>
                            </button>
                            <div class="clearfix"></div>
                          </div>
                        </div>
                        <div class="modal-body">
              <div class="row mb-4">
                <div class="col-9 pl-3">
                  <div class="h3 d-inline mr-2 text-uppercase">Create New Group</div>
                  
                </div>
              </div>                            
                            <form @submit.prevent="saveGroup" v-if="!isSuccessPanel">
                                <div class="row">
                                    <div class="col-12">
                                        <label class="form-label">Group Name</label>
                                        <input
                                            type="text"
                                            id="group_name"
                                            class="col-12 col-sm-12 input-height-35 form-control"
                                            ref="group_name"
                                            name="group_name"
                                            v-model="group_name"
                                            v-validate="{ rules: { required: true, regex: nameRegex() } }"
                                            placeholder="Enter Group Name"
                                            maxlength="250"
                                            autocomplete="off">
                                        <div v-if="verrors.firstByRule('group_name', 'required')" class="margin-bottom-5 validate-warning-msg">Group name is required</div>
                                        <div v-if="verrors.firstByRule('group_name', 'regex')" class="margin-bottom-5 validate-warning-msg">Group name should only contain - and _</div>
                                        <div v-if="groupExists" class="text-red">{{ groupExists }}</div>
                                    </div>
                                </div>
                                <div class="row submit_row justify-content-md-center">
                                    <div class="col-6">
                                        <button type="submit" class="btn btn-sm btn-blue saveBtn text-center">Create New Group</button>
                                    </div>
                                </div>
                            </form>
                            <div v-else>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="successPanel">
                                            <div class="col-9">
                                                <p class="success-msg">Success!</p>
                                                <p class="success-note">
                                                    <i class="fa fa-check-circle-o"></i>
                                                    New Group Created
                                                </p>
                                            </div>
                                            <div class="col-3 mt-3">
                                                <img src="@/assets/enterprise/Required_Rocket_Image_106x101.png" width="70" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row gotoBtn justify-content-md-center">
                                    <div class="col-4">
                                        <button type="button" class="btn btn-sm btn-blue saveBtn text-center" @click="goToGroup">Go to Group</button>
                                    </div>
                                </div>
                                <div class="row mt-4 justify-content-md-center">
                                    <div class="col-4">
                                        <button type="button" class="btn btn-sm btn-blue closeBtn text-center" @click="close">Close Window</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <ExistingGroup
            :isModalExistingGroupVisible="isModalExistingGroupVisible" 
            :accountId="accountId"
            @close="closeExistingGroupSidebar"
            ref="existing_group_panel" 
        />

    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import ExistingGroup from './existing_group.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['isModalGroupVisible', 'accountId'],
    data() {
        return {
            loading: false,
            isSuccessPanel: false,
            group_name: '',
            groupExists: '',
            group_id: '',
            isModalExistingGroupVisible: false,
        }
    },
    components: {
        ExistingGroup,
    },
    methods: {
        hide() {
            this.close();
        },
        close() {
            this.verrors.clear();
            this.$emit('close');
        },
        nameRegex() {
            return /^[a-zA-Z-_ ']*$/;
        },
        saveGroup() {
            this.groupExists = '';
            this.$validator.validateAll().then((result) => {
                if (this.verrors.items.length === 0) {
                    this.loading = true;
                    axios('/enterprise-admin/add-new-group', 
                    {
                        method: 'POST',
                        data: {
                            group_name: this.group_name
                        },
                    })
                    .then((resp) => {
                        this.loading = false;
                        this.verrors.clear();
                        this.group_id = resp.data.id;
                        if (resp.data.id) {
                            this.isSuccessPanel = true;
                        }
                    })
                    .catch(error => {
                        if(error.response) {
                            const fieldErrors =  [];
                            // var errMsgObj = error.response.data.message.group_name;
                            var errMsgObj = JSON.parse(error.response.data.message);
                            errMsgObj = errMsgObj.group_name;
                            this.groupExists = errMsgObj;
                        }
                    });
                }
            });
        },
        goToGroup() {
            this.isModalExistingGroupVisible = true;
            this.accountId = this.accountId;
            this.$refs.existing_group_panel.getGroupData(this.group_id, this.group_name);
        },
        closeExistingGroupSidebar() {
            this.isModalExistingGroupVisible = false;
        }
    },
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}
@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.saveBtn, .saveBtn:hover, .saveBtn:active, .saveBtn:focus {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: 100%;
}
.closeBtn {
    color: #00acee; 
    background-color: #FFF !important;
    border: 1px solid #00acee !important;
    border-radius: 10px;
    font-weight: 900;
    width: 100%;
}
.mx-input { height: 24px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;
  background-color: #efefef;
  min-height: 30px;
  border-radius: 5px;
}
.ma-input-field:focus-visible {
  outline: none;
}
.form-label { font-size: 13px; font-weight: 900; } 
.submit_row { margin: 4rem; }
.successPanel { 
    background-color: #28a745;
    color: #FFF;
    padding: 10px;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
}.
.success-msg { font-size:  1.5rem; font-weight: 900;}
.success-note i { font-size: 1.25rem; margin-right: 10px; }
.gotoBtn { margin-top: 16rem; }
.text-red { color: #dc3545 !important; font-weight: 900; }
input, select {
    line-height: 17px;
    border-radius: 10px;
    padding-left: 5px !important;
    border: 1px solid #707070;
}
.back_icon { width: 14px; }
a, a:hover {
    text-decoration: none;
}

</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/add_new_group.vue